// Import Core
import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
// Import Components
import Button from "../ui/buttons/Button";
// Import configData
import configData from "../../../configData.json";
import { toSlug } from "../../utils/search/toSlug";

const TableStyling = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: 100%;
  position: relative;
  @media (max-width: 992px) {
    overflow: scroll;
    /* Hide scrollbar for table scrolling on mobile */
    &::-webkit-scrollbar {
      display: none; //for Chrome, Safari and Opera
    }
    -ms-overflow-style: none; // IE and Edge
    scrollbar-width: none; // Firefox
  }

  #table {
    border-collapse: collapse;
    width: 100%;
    thead {
      width: 100%;
      border: 1px solid var(--neutral-25);
      @media (max-width: 992px) {
        display: none;
      }
      tr {
        width: 100%;
        border-bottom: 1px solid var(--neutral-25);
        th {
          padding: 10px 24px;
          text-align: left;
          @media (max-width: 992px) {
            padding: 8px 20px;
          }
          .title {
            text-transform: uppercase;
            font-family: var(--font-family-heading);
          }
        }
      }
    }
    tbody {
      tr {
        border: 1px solid var(--neutral-25);
        @media (max-width: 992px) {
          border: none;
        }
        td {
          border-bottom: 1px solid var(--neutral-25);
          height: 56px;
          padding: 16px 24px;
          overflow: hidden;
          color: var(--black);
          text-overflow: ellipsis;
          @media (max-width: 992px) {
            border-left: 1px solid var(--neutral-25);
            border-right: 1px solid var(--neutral-25);
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: unset;
            padding: 8px 20px;
          }
          &.blue {
            color: var(--blue);
          }
          .mobile-title {
            display: none;
            text-transform: uppercase;
            font-family: var(--font-family-heading);
            color: var(--black);
            @media (max-width: 992px) {
              display: block;
            }
          }
          &.links-wrapper {
            .links {
              display: flex;
              gap: 8px;
              flex-flow: wrap;
              a {
                color: var(--red);
                text-decoration: underline;
                &.orange {
                  color: var(--orange-120);
                }
              }
            }
          }
          button {
            min-width: fit-content;
          }
          &:first-child {
            .mobile-title {
              @media (max-width: 992px) {
                display: none;
              }
            }
          }
          @media (max-width: 992px) {
            &:first-child {
              border-top: 1px solid var(--grey-25);
            }
            /* Only if button true! */
            &:last-child {
              width: 100%;
              display: flex;
              margin-bottom: 20px;
              &:has(button) {
                border-left: none;
                border-right: none;
                border-bottom: none;
                height: unset;
                padding: 0;
                margin: 20px 0 32px;
                button {
                  width: 100%;
                }
              }
              .enquiry-link{
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  &.ct-single {
    max-width: 1440px;
    margin: 0 auto;
    padding: var(--global-padding);
    align-items: flex-start;

    @media (max-width: 992px) {
      padding: var(--global-padding-mobile);
    }
    #table {
      tbody {
        tr {
          td {
            font-weight: 400;
            font-family: var(--font-family-base);

            &:first-child {
              .mobile-title {
                @media (max-width: 992px) {
                  display: block;
                }
              }
            }
            &:nth-child(2) {
              color: var(--red);
            }

            &:nth-child(3) {
              color: var(--blue);
            }

            .closed {
              color: var(--black-50);
            }
          }
        }
      }
    }
  }
`;

const Table = ({
  addToAnchor,
  title,
  tableColumns,
  tableData,
  productType,
  productTitle,
  productDatedDarwinId,
  productDepartDate,
  productDuration,
  productSingleSup,
  productPrice,
  className,
  depositOverride,
}) => {
  //   useEffect(() => {
  //     // gsap.registerPlugin(ScrollTrigger);

  // // const cards = document.querySelectorAll(".table");

  // // gsap.set(cards, {position: 'absolute'})

  // // gsap.to(".card", {
  // //   yPercent: -100,
  // //   stagger: 0.5,
  // //   scrollTrigger: {
  // //     trigger: ".cards",
  // //     pin: true,
  // //     markers: true,
  // //     scrub: 1,
  // //     start: "top top",
  // //     end: "bottom top",
  // //     snap: {
  // //         snapTo: 0.33,
  // //         duration: {min: 0.1, max: 0.4},
  // //         ease: "power1.inOut"
  // //       }
  // //   }
  // // });

  //   })

  const renderTableHeader = () => {
    return (
      tableColumns &&
      tableColumns.map((title, i) => {
        return (
          <th key={`td-${i}`}>
            <h5 className="title">{title}</h5>
          </th>
        );
      })
    );
  };

  const renderTableData = () => {
    return (
      tableData &&
      tableData.map((row, i) => {
        return (
          <tr className="pin-table" key={`tr-${i}`}>
            {row.map((item, index) => {
              // If array or object we need to output correct elements (links, button, etc)
              if (typeof item === "object" && item !== null) {
                if (item.length > 0 && "link" in item[0]) {
                  return (
                    <td className="links-wrapper" key={index}>
                      <h5 className="mobile-title">{tableColumns[index]}</h5>
                      <span className="links">
                        {item.map((button, i) => (
                          <Link
                            to={button.link}
                            className={button.className}
                            key={`btn-${i}`}
                          >
                            <p>{button.name}</p>
                          </Link>
                        ))}
                      </span>
                    </td>
                  );
                } else if (item.slug) {
                  return (
                    <td key={index}>
                      {item.slug === configData.enquiry.enquiry.link ? (
                        <React.Fragment>
                          {productType === "event" ? null : (
                            <Link
                              to={item.slug}
                              className="enquiry-link"
                              style={{ marginRight: "12px" }}
                              state={{
                                productType: productType,
                                productTitle: productTitle,
                                productDatedDarwinId: productDatedDarwinId[i],
                                productDepartDate: productDepartDate[i],
                                productDuration: productDuration[i],
                                productPrice: productPrice[i],
                                productSingleSup: productSingleSup[i],
                                isBooking: false,
                                depositOverride: depositOverride,
                                formType: "enquiry",
                              }}
                            >
                              <Button
                                size="md"
                                btnStyle="outline"
                                className=""
                                value={"Enquire"}
                                clickHandler={false}
                                isDisabled={false}
                              />
                            </Link>
                          )}

                          <Link
                            to={item.slug}
                            className="enquiry-link"
                            state={{
                              productType: productType,
                              productTitle: productTitle,
                              productDatedDarwinId: productDatedDarwinId[i],
                              productDepartDate: productDepartDate[i],
                              productDuration: productDuration[i],
                              productPrice: productPrice[i],
                              productSingleSup: productSingleSup[i],
                              isBooking: true,
                              depositOverride: depositOverride,
                              formType: "booking",
                            }}
                          >
                            <Button
                              size="md"
                              btnStyle="outline"
                              className=""
                              value="Book"
                              clickHandler={false}
                              isDisabled={false}
                            />
                          </Link>
                        </React.Fragment>
                      ) : item.slug === configData.enquiry.phone_alt.link ? (
                        <Link to={item.slug} className="enquiry-link">
                          <Button
                            size="md"
                            btnStyle="outline"
                            className=""
                            value={"Call 020 7593 2284"}
                            clickHandler={false}
                            isDisabled={false}
                          />
                        </Link>
                      ) : (
                        <Link to={item.slug}>
                          <Button
                            size="md"
                            btnStyle="outline"
                            className=""
                            value={"View"}
                            clickHandler={false}
                            isDisabled={false}
                          />
                        </Link>
                      )}
                    </td>
                  );
                } else {
                  return (
                    <td key={index}>
                      <h5 className="mobile-title">{tableColumns[index]}</h5>
                      ---
                    </td>
                  );
                }
              } else if (item !== null) {
                return (
                  <td
                    className={index === 0 ? "bold" : index === 3 ? "blue" : ""}
                    key={index}
                  >
                    <h5 className="mobile-title">{tableColumns[index]}</h5>
                    {item === "Closed" ? (
                      <span className="closed">{item}</span>
                    ) : (
                      item
                    )}
                    {/* {item} */}
                  </td>
                );
              }
            })}
          </tr>
        );
      })
    );
  };

  return (
    <TableStyling
      id={addToAnchor && title ? `anchor_${toSlug(title)}` : ""}
      className={`table ${className}${addToAnchor ? " anchor-link" : ""}`}
    >
      <div className="section-title">
        <h3 id="title">{title}</h3>
      </div>

      <table id="table">
        <thead>
          <tr>
            {renderTableHeader()}
            <th></th>
          </tr>
        </thead>
        <tbody>{renderTableData()}</tbody>
      </table>
    </TableStyling>
  );
};

export default Table;
